import { render, staticRenderFns } from "./PodaciZaposlenog.vue?vue&type=template&id=4ad13d13&scoped=true&"
import script from "./PodaciZaposlenog.vue?vue&type=script&lang=ts&"
export * from "./PodaciZaposlenog.vue?vue&type=script&lang=ts&"
import style0 from "./PodaciZaposlenog.vue?vue&type=style&index=0&id=4ad13d13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad13d13",
  null
  
)

export default component.exports